/** SVG/canvas path for a filled pie or donut sector. */
export function arcSectorPath(cx, cy, outerR, startAngle, endAngle, innerR, counterClockwise) {
    if (innerR === void 0) { innerR = 0; }
    if (counterClockwise === void 0) { counterClockwise = false; }
    var sweep = counterClockwise ? 0 : 1;
    var large = Math.abs(endAngle - startAngle) > Math.PI ? 1 : 0;
    var ox1 = cx + outerR * Math.cos(startAngle);
    var oy1 = cy + outerR * Math.sin(startAngle);
    var ox2 = cx + outerR * Math.cos(endAngle);
    var oy2 = cy + outerR * Math.sin(endAngle);
    if (innerR > 0 && innerR < outerR) {
        var ix1 = cx + innerR * Math.cos(endAngle);
        var iy1 = cy + innerR * Math.sin(endAngle);
        var ix2 = cx + innerR * Math.cos(startAngle);
        var iy2 = cy + innerR * Math.sin(startAngle);
        var innerSweep = counterClockwise ? 1 : 0;
        return "M ".concat(ox1, " ").concat(oy1, " A ").concat(outerR, " ").concat(outerR, " 0 ").concat(large, " ").concat(sweep, " ").concat(ox2, " ").concat(oy2, " L ").concat(ix1, " ").concat(iy1, " A ").concat(innerR, " ").concat(innerR, " 0 ").concat(large, " ").concat(innerSweep, " ").concat(ix2, " ").concat(iy2, " Z");
    }
    return "M ".concat(cx, " ").concat(cy, " L ").concat(ox1, " ").concat(oy1, " A ").concat(outerR, " ").concat(outerR, " 0 ").concat(large, " ").concat(sweep, " ").concat(ox2, " ").concat(oy2, " Z");
}
/** Trace a pie or donut sector on a Canvas 2D context (local coords; center at cx,cy). */
export function traceArcSector(ctx, cx, cy, outerR, startAngle, endAngle, innerR, counterClockwise) {
    if (innerR === void 0) { innerR = 0; }
    if (counterClockwise === void 0) { counterClockwise = false; }
    ctx.beginPath();
    if (innerR > 0 && innerR < outerR) {
        ctx.arc(cx, cy, outerR, startAngle, endAngle, counterClockwise);
        ctx.arc(cx, cy, innerR, endAngle, startAngle, !counterClockwise);
        ctx.closePath();
    }
    else {
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, outerR, startAngle, endAngle, counterClockwise);
        ctx.closePath();
    }
}
